import axios from "infra/http";
import { useQuery } from "react-query";
import { FornecedorEndereco } from './../typings/index';


function usePutFornecedorEndereco(id?: string) {
    return useQuery(
        `/v1/fornecedor/${id}/endereco`,
        async () => {
            const res = await axios.get<FornecedorEndereco>(`/v1/fornecedor/${id}/endereco`);

            return res.data;
        },
        {
            enabled: !!id,
        }
    );
}

export default usePutFornecedorEndereco;
